import {
  GET_TEAM,
  RECEIVED_TEAM,
  GET_TEAM_SUCCESS,
  GET_TEAM_FAILED,
  INVITE_TEAM,
  INVITE_TEAM_SUCCESS,
  INVITE_TEAM_FAILED,
  RESET_INVITE_STATUS,
  DELETE_TEAM,
  DELETE_TEAM_SUCCESS,
  DELETE_TEAM_FAILED,
  RESET_DELETE_STATUS,
  RESET_TEAM_ERROR,
} from "./actionType";

/**
 * GET
 */
export const getTeam = () => ({
  type: GET_TEAM,
});

export const getTeamSuccess = (team) => ({
  type: GET_TEAM_SUCCESS,
  payload: team,
});

export const receivedTeam = (team) => ({
  type: RECEIVED_TEAM,
  payload: team,
});

export const getTeamFailed = (error) => ({
  type: GET_TEAM_FAILED,
  payload: error,
});

/**
 * INVITE
 */
export const inviteTeam = (teamDetails) => ({
  type: INVITE_TEAM,
  payload: { teamDetails },
});

export const inviteTeamSuccess = () => ({
  type: INVITE_TEAM_SUCCESS,
});

export const inviteTeamFailed = (error) => ({
  type: INVITE_TEAM_FAILED,
  payload: error,
});

export const resetInviteTeamStatus = () => ({
  type: RESET_INVITE_STATUS,
});

/**
 * DELETE
 */
export const deleteTeam = (teamId) => ({
  type: DELETE_TEAM,
  payload: { teamId },
});

export const deleteTeamSuccess = () => ({
  type: DELETE_TEAM_SUCCESS,
});

export const deleteTeamFailed = (error) => ({
  type: DELETE_TEAM_FAILED,
  payload: error,
});

export const resetDeleteStatus = () => ({
  type: RESET_DELETE_STATUS,
});

export const resetTeamError = () => ({
  type: RESET_TEAM_ERROR,
});
